import { render, staticRenderFns } from "./DepartUserList.vue?vue&type=template&id=4bb06339&scoped=true&"
import script from "./DepartUserList.vue?vue&type=script&lang=js&"
export * from "./DepartUserList.vue?vue&type=script&lang=js&"
import style0 from "./DepartUserList.vue?vue&type=style&index=0&id=4bb06339&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb06339",
  null
  
)

export default component.exports